import { Filter } from '@fabric-ui/components';
import { FieldType } from '../../views/Sources/Mapping/types';

const FILTER_METADATA_KEYS = new Set(['isHistorical', '_metadata']);

export const isDateFilterField = (fieldName: string | null | undefined, fieldMap: Record<string, { type?: unknown }>): boolean =>
  !!fieldName && [FieldType.Date, FieldType.DateTime].includes(fieldMap[fieldName]?.type as string);

export const preserveFilterMetadata = (filter: Filter): Partial<Filter & { _metadata?: unknown }> =>
  Object.fromEntries(Object.entries(filter).filter(([key]) => FILTER_METADATA_KEYS.has(key))) as Partial<Filter & { _metadata?: unknown }>;
